"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperatorSelect = void 0;
const alchemy_ui_1 = require("@m/alchemy-ui");
const react_1 = __importDefault(require("react"));
const operators_1 = require("../operators");
const utils_1 = require("../../../../common/utils");
const SelectFromListText = 'app.pages.forms.builder.tabs.fieldSettings.conditionalDisplayModal.selectFromList';
const OperatorSelect = (props) => {
    var _a;
    const conditionDefinition = props.conditionDefinition;
    if (conditionDefinition == null) {
        return null;
    }
    return (react_1.default.createElement(alchemy_ui_1.Field, { isFullWidth: true, status: props.operator.meta.error && props.operator.meta.touched ? { level: 'error', message: props.operator.meta.error } : undefined, input: react_1.default.createElement(alchemy_ui_1.Select, { disabled: props.disabled, placeholder: (0, utils_1.getSingleText)(SelectFromListText), value: (_a = props.operator.input.value) !== null && _a !== void 0 ? _a : '', options: createOperatorsOptions(conditionDefinition.operators), onChange: (option) => {
                if (shouldResetValue(option.value, props.operator, props.subject)) {
                    props.value.input.onChange(undefined);
                }
                else {
                    props.value.input.onChange(props.value.input.value);
                }
                props.operator.input.onChange(option.value);
            } }) }));
};
exports.OperatorSelect = OperatorSelect;
const createOperatorsOptions = (operators) => {
    return operators.map(item => ({
        label: (0, operators_1.getOperatorLabel)(item),
        value: item
    }));
};
const shouldResetValue = (newOperator, operator, subject) => {
    if (operator.input.value == null) {
        return false;
    }
    else if (newOperator == null || newOperator === operators_1.operators.hasValue || newOperator === operators_1.operators.hasNoValue) {
        return true;
    }
    else if (subject.type.input.value === 'component' && subject.componentType.input.value === 'checkbox' && (0, operators_1.isMultiOperator)(newOperator) !== (0, operators_1.isMultiOperator)(operator.input.value)) {
        return true;
    }
    else {
        return false;
    }
};
